import { useEffect, useState } from "react";

const useTimer = (initialDate) => {
  const [time, setTime] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const result = timeDifference();
      setTime(result);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  const timeDifference = () => {
    const currentDate = new Date();
    const savedDate = new Date(initialDate);

    const secs = Math.floor((currentDate - savedDate) / 1000);

    let hours = Math.floor(secs / 3600);
    let minutes = Math.floor(secs / 60) % 60;
    let seconds = secs % 60;
    return [hours, minutes, seconds]
      .map((v) => ("" + v).padStart(2, "0"))
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  return [time];
};

export default useTimer;
